import { cn } from '#app/utils/tailwind-merge.ts'
import { HashLink } from './hash-link.tsx'

export function JoinList({ className }: { className?: string }) {
	return (
		<HashLink
			href="#list"
			className={cn(
				'inline-flex items-center justify-center border border-navy px-5 py-3 text-sm font-medium tracking-wide text-navy transition-colors duration-150 hover:bg-navy hover:text-cream active:scale-[0.98]',
				className,
			)}
		>
			Join the list
		</HashLink>
	)
}
